module.exports = __webpack_public_path__ + "img/check-green.b372486b.svg";